import { render } from "./Dropbox.vue?vue&type=template&id=7d12a76e"
import script from "./Dropbox.vue?vue&type=script&lang=js"
export * from "./Dropbox.vue?vue&type=script&lang=js"

import "./Dropbox.vue?vue&type=style&index=0&id=7d12a76e&lang=css"

import exportComponent from "/home/appfloretcollegein/app.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__